(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('CampaignContentController', CampaignContentController);

    /** @ngInject */
    function CampaignContentController($scope, $translate, CampaignService, $uibModal, MODAL_CONTENT_TYPES,
                                       UserService, $localStorage, moment) {
        var vm = this;

        vm.totalActivities = 0;
        vm.totalActivitiesFinished = 0;
        vm.percentage = 0;
        vm.sellers = [];
        vm.dateFormat = $translate.instant('momentDateFormat');

        vm.close = function () {
            if (vm.onClose) {
                vm.onClose();
            }
        };

        const DATE_FORMAT = $translate.instant('momentDateFormat');

        function calculatePercentage(done, total) {
            return total > 0 ? ((done / total) * 100).toFixed(0) : '0';
        }

        vm.onInit = function () {
            vm.isHubContext = $localStorage.defaultStore.hubContext;
            vm.dynamicFilterOptions = {
                users: getDynamicFilterOptionsModel(true)
            }

            vm.listUsersFilterOptions = UserService.getUsersSellersByStore;

            vm.hasCampaignDistribution = false;

            CampaignService.get(vm.campaign.id).then(function (result) {
                vm.campaign = result.data.campaign;
                vm.sellers = result.data.sellers;
                vm.totalActivities = result.data.totalActivities;
                vm.totalActivitiesFinished = result.data.totalActivitiesFinished;
                vm.percentage = calculatePercentage(vm.totalActivitiesFinished, vm.totalActivities);
                vm.hasCampaignDistribution = vm.campaign && angular.isObject(vm.campaign.sellerSelection);
                vm.selectedUsers = vm.campaign.sellerSelection || getSelectAllPaginatedModel();
                vm.hasSellerSelection = vm.selectedUsers && vm.selectedUsers.all ||
                    (vm.selectedUsers.only && vm.selectedUsers.only.length > 0) ||
                    (vm.selectedUsers.except && vm.selectedUsers.except.length > 0);
            });
            if(vm.campaign.expirationDate) {
                vm.formatedExpirationDate =  moment(vm.campaign.expirationDate).format(DATE_FORMAT);
            }
        };

        vm.openViewTargetAudienceMenu = function () {
            vm.close();


            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/create-target-audience/create-target-audience.html',
                controller: 'CreateTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal full-screen-modal',
                backdrop: 'static',
                resolve: {

                    targetAudienceId: function () {
                        return vm.campaign.targetAudienceId;
                    },
                    isViewMode: function () {
                        return true;
                    }
                }
            }).result.then(function (createdItem) {
                vm.reOpenViewCampaignMenu();
            });
        };

        vm.reOpenViewCampaignMenu = function (campaign) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            campaign: vm.campaign,
                            isHub: vm.isHub,
                            type: MODAL_CONTENT_TYPES.CAMPAIGN

                        }
                    }
                }
            }).result.then();
        };


    }
})();
